import { setTasksVisualizationGraphType as setTasksVisualizationGraphTypeDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & {
    type?: Number,
}

export const setTasksVisualizationGraphType = ({
    type,
    eventEmitter,
}: Props) => {
    setTasksVisualizationGraphTypeDiagram(type);
};
